// This is the single source of truth for all quiz files.
// This file is automatically generated by the python script: generate_manifest.py
// Do not edit this file manually if you plan to use the script again.

export const quizManifest = [
    'Davidson Medicine - Cardiology – Acute coronary syndrome.json',
    'Davidson Medicine - Cardiology – Angina.json',
    'Davidson Medicine - Cardiology – Cardiac arrhythmias and Principles of management.json',
    'Davidson Medicine - Cardiology – Congenital Heart Disease.json',
    'Davidson Medicine - Cardiology – Disease of Aorta.json',
    'Davidson Medicine - Cardiology – Diseases of Heart valve.json',
    'Davidson Medicine - Cardiology – Diseases of Myocardium.json',
    'Davidson Medicine - Cardiology – Diseases of pericardium.json',
    'Davidson Medicine - Cardiology – Hypertension.json',
    'Davidson Medicine - Cardiology – Myocardial Infarction.json',
    'Davidson Medicine - Cardiology – Peripheral Arterial Disease.json',
    'Davidson Medicine - Dermatology – Acne and rosacea.json',
    'Davidson Medicine - Dermatology – Bullous diseases.json',
    'Davidson Medicine - Dermatology – Common skin infections and infestations.json',
    'Davidson Medicine - Dermatology – Eczemas.json',
    'Davidson Medicine - Dermatology – Hair disorders.json',
    'Davidson Medicine - Dermatology – Lichenoid eruptions.json',
    'Davidson Medicine - Dermatology – Nail disorders.json',
    'Davidson Medicine - Dermatology – Pigmentation disorders.json',
    'Davidson Medicine - Dermatology – Principles of management of skin disease.json',
    'Davidson Medicine - Dermatology – Psoriasis and other erythematous scaly eruptions.json',
    'Davidson Medicine - Dermatology – Skin Tumors.json',
    'Davidson Medicine - Dermatology – Skin disease in general medicine.json',
    'Davidson Medicine - Dermatology – Urticaria.json',
    'Davidson Medicine - Diabetes Mellitus.json',
    'Davidson Medicine - Infectious Diseases – Bacterial infections.json',
    'Davidson Medicine - Infectious Diseases – Ectoparasites.json',
    'Davidson Medicine - Infectious Diseases – Fungal infections.json',
    'Davidson Medicine - Infectious Diseases – Infections caused by helminths.json',
    'Davidson Medicine - Infectious Diseases – Prion disease.json',
    'Davidson Medicine - Infectious Diseases – Protozoal infections.json',
    'Davidson Medicine - Infectious Diseases – Viral infections.json',
    'Davidson Medicine - Respiratory System – Diseases of the diaphragm and chest wal.json',
    'Davidson Medicine - Respiratory System – Diseases of the upper airway.json',
    'Davidson Medicine - Respiratory System – Functional anatomy and physiology.json',
    'Davidson Medicine - Respiratory System – Infections of the respiratory system.json',
    'Davidson Medicine - Respiratory System – Interstitial and infiltrative pulmonary diseases.json',
    'Davidson Medicine - Respiratory System – Obstructive pulmonary diseases.json',
    'Davidson Medicine - Respiratory System – Occupational and environmental lung disease.json',
    'Davidson Medicine - Respiratory System – Pleural disease.json',
    'Davidson Medicine - Respiratory System – Presenting problems in respiratory disease.json',
    'Davidson Medicine - Respiratory System – Pulmonary vascular disease.json',
    'Davidson Medicine - Respiratory System – Tumours of the bronchus and lung.json',
    'Davidson Medicine - Stroke Medicine.json',
    'ECG - Dubin ECG (Ch 1 – Basic Principles).json',
    'ECG - Dubin ECG (Ch 2 – Recording ECG).json',
    'ECG - Dubin ECG (Ch 3 – Autonomic NS).json',
    'ECG - Dubin ECG (Ch 4 – Rate).json',
    'ECG - Dubin ECG (Ch 5 – Rhythm I – Arrhythmia of Focal Origin).json',
    'ECG - Dubin ECG (Ch 6 – Rhythm II – Blocks).json',
    'ECG - Dubin ECG (Ch 7 – Axis).json',
    'ECG - Dubin ECG (Ch 8 – Hypertrophy).json',
    'ECG - Dubin ECG (Ch 9 – Infarction).json',
    'PassMedicine - Clinical Science 1.json',
    'PassMedicine - Clinical Science 2.json',
    'PassMedicine - Clinical Science 3.json',
    'PassMedicine - GIT 1.json',
    'PassMedicine - GIT 2.json',
    'PassMedicine - Nephrology.json',
    'PassMedicine - Psychiatry.json',
    'PassMedicine - Respiratory.json',
    'PassMedicine - Rheumatology 1.json',
    'PassMedicine - Rheumatology 2.json',
    'PassMedicine - Rheumatology 3.json',
    'Ratin Selection Medicine - Antibiotics.json',
    'Ratin Selection Medicine - Antihypertensive.json',
];
